import React, { Component } from 'react'
import validator from 'validator'
import TagManager from 'react-gtm-module'
import {AppContext} from "@lightspeed-invoicing/core-client/frontend";

const GoogleTagManagerTracking = (WrappedComponent) => {

    const trackPage = (page) => {
        const info = extractInfoFromPathName(page)
        TagManager.dataLayer({
            dataLayer: {
                userId: AppContext.isAuthenticated() ? AppContext.getUserLoggedIn().id : '',
                accountId: AppContext.isAuthenticated() ? AppContext.getAccount().id : '',
                email: AppContext.isAuthenticated() && AppContext.getUserLoggedIn().attributes ? AppContext.getUserLoggedIn().attributes.email : '',
                page: info.route,
                location: window.location.href,
                event: 'sendUserInfo'
            },
            events: {
                customPageView: 'customPageView'
            },
            dataLayerName: 'PageDataLayer'
        })

    }

    const extractInfoFromPathName = (pathname) => {
        const seg = pathname.split('?')[0].split('/')
        return {
            path: pathname,
            route: seg.map(r => {
                if (validator.isUUID(r) || validator.isHash(r, 'sha1')) {
                    return '{id}'
                } else {
                    return r
                }
            }).join('/'),
            ids: seg.filter(r => (validator.isUUID(r) || validator.isHash(r, 'sha1')))
        }
    }

    const HOC = class extends Component {

        componentDidMount() {
            const page = this.props.location.pathname
            trackPage(page)
        }

        componentWillReceiveProps(nextProps) {
            const currentPage = this.props.location.pathname
            const nextPage = nextProps.location.pathname

            if (currentPage !== nextPage) {
                trackPage(nextPage)
            }
        }

        render() {
            return <WrappedComponent {...this.props} />
        }
    }

    return HOC
}

export default GoogleTagManagerTracking



// WEBPACK FOOTER //
// ./src/common/GoogleTagManagerTracking.jsx